import { TrashIcon, UpdateIcon } from '@radix-ui/react-icons';
import { useState } from 'react';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription, DialogHeader,
    DialogTitle,
    DialogTrigger
} from "../ui/dialog";
import { DropdownMenuItem } from "../ui/dropdown-menu";

import sport_classes from '../../enums/sport_classes.json';
import api from '../../lib/api';
import { toast } from '../ui/use-toast';

const DeleteCompetitionSportClassDialog = ({ sportClass, fetchCompetition }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [err, setError] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleChange = async (e) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);
        try {
            const response = await api.post(`https://skhrf-api.cmdigital.se/v1/competitions/delete-class`, {
                sportClassId: sportClass.id,
            });

            fetchCompetition();
            toast({
                title: 'Klass borttagen',
                description: `Klass ${getSportClassNameById(sportClass.sport_class_id)} blev borttagen.`,  // Using full class name
            });
            setIsDialogOpen(false);
        } catch (error) {

            setError(error?.response?.data?.error);
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error?.response?.data?.error,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const getSportClassNameById = (id) => {
        const sportClass = sport_classes.find((sport_class) => sport_class.id === id);
        return sportClass ? sportClass.sport_class_name : "Okänd klass"; // Fallback if ID is not found
    };

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DropdownMenuItem
                className={`text-destructive w-full`}
                onSelect={(event) => event.preventDefault()}>
                <DialogTrigger className='flex items-center w-full'>
                    <TrashIcon className='mr-3' />
                    Ta bort klass
                </DialogTrigger>
            </DropdownMenuItem>
            <DialogContent className="flex flex-col gap-6">
                <DialogHeader className='text-left'>
                    <DialogTitle>
                        Ta bort klass
                    </DialogTitle>
                    <DialogDescription>
                        Är du helt säker? Denna åtgärd går inte att ångra.
                    </DialogDescription>
                </DialogHeader>
                <div className='grid grid-cols-2 gap-3'>
                    <DialogClose asChild>
                        <Button type='button' variant='secondary'>Avbryt</Button>
                    </DialogClose>
                    <Button
                        variant='destructive'
                        onClick={handleChange}
                        disabled={isLoading}>
                        {(isLoading) ? <UpdateIcon className='loader-spinner' /> : <>Ta bort</>}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default DeleteCompetitionSportClassDialog;
